import { useEffect, useState } from "react";

// Firebase web config for loftgaedi-is. These values identify the project and
// are public by design; access to listings is checked by the function.
const FIREBASE_CONFIG = {
  apiKey: "AIzaSyCZ8tNXtvPnSvfpgqBCJmy0j_9csIUebPA",
  authDomain: "loftgaedi-is.firebaseapp.com",
  projectId: "loftgaedi-is",
  appId: "1:545560819151:web:80989f4bedb59ea344ceba",
};

// Firebase is only downloaded once something needs sign-in, so the public
// map doesn't carry it
let loading;
const loadAuth = () => {
  loading ??= Promise.all([
    import("firebase/app"),
    import("firebase/auth"),
  ]).then(([app, auth]) => ({
    ...auth,
    auth: auth.getAuth(app.initializeApp(FIREBASE_CONFIG)),
  }));
  return loading;
};

// The signed-in Google user while `enabled`; `ready` once Firebase has
// restored any earlier session
export const useGoogleUser = (enabled) => {
  const [state, setState] = useState({ user: null, ready: false });

  useEffect(() => {
    if (!enabled) return undefined;
    let unsubscribe;
    let cancelled = false;
    loadAuth().then(({ auth, onAuthStateChanged }) => {
      if (cancelled) return;
      unsubscribe = onAuthStateChanged(auth, (user) =>
        setState({ user, ready: true }),
      );
    });
    return () => {
      cancelled = true;
      unsubscribe?.();
    };
  }, [enabled]);

  return state;
};

export const signInWithGoogle = async () => {
  const { auth, GoogleAuthProvider, signInWithPopup } = await loadAuth();
  await signInWithPopup(auth, new GoogleAuthProvider());
};

export const signOutOfGoogle = async () => {
  const { auth, signOut } = await loadAuth();
  await signOut(auth);
};
